import { Directive, Input, Output, EventEmitter, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

import { Subject, Observable, Subscription, timer } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';

@Directive({
    selector: '[counter]',
    standalone: false
})
export class CounterDirective implements OnChanges, OnDestroy {
    @Input() counter: number;
    @Output() value = new EventEmitter<number>();
    private counterSource$ = new Subject<any>();
    private subscription = Subscription.EMPTY;
    private interval = 1000;

    constructor() {
        this.subscription = this.counterSource$.pipe(
            switchMap(({ interval, count }) =>
                timer(0, interval).pipe(
                    take(count),
                    tap(() => this.value.emit(--count))
                )
            )
        ).subscribe();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.startTimer();
    }

    public startTimer() {
        this.counterSource$.next({ count: this.counter, interval: this.interval });
    }

    public endTimer() {
        this.counterSource$.next({ count: 1, interval: 0 });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
